/**
 * 增值服务订单管理
 */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.module.scss';
import { connect } from 'react-redux';
import moment from 'moment';
import { setBreadcrumbPaths } from '@/reducers/home/actions';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton, } from '@/components/xqxc_ui';
import TableContent from './components/OrderTable';
import KeepAlive from '@/routes/KeepAlive';
import model from '@/reducers/order/serviceorder/model';
import commonModel from '@/reducers/operation/city/model';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';

class Main extends React.Component {

    state = {
        payAccessType: {}, // 推广类型
        status: {}, // 状态
        shareLoading: false,
        companyItem: {},
    };

    componentDidMount() {
        this.props.setBreadcrumbPaths(this.props.match); // 自动识别面包屑
        this.props.getBrokerReferrerRoleEnum({ enumName: 'BrokerReferrerRoleEnum' });
        this.props.getOrderStatusEnum({ enumName: 'OrderStatusEnum' });
        this.props.getCompanySele({ pageNum: 1, pageSize: 100000 });
    }

    // 表格操作
    _tableAction = (key, type, record) => {
        const { history } = this.props;
        switch (type) {
            // 详情
            case 'info':
                history.push({
                    pathname: `/home/order/serviceorder/orderdetail/${record.id}`,
                });
                break;
        }
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageSize, pageNum, id, payAccessType, recommendMobile, companyItem, status, payTimeStart, payTimeEnd } = this.state;
        const query = {
            id,
            recommendType: payAccessType.code == 0 ? undefined : payAccessType.code,
            recommendMobile: payAccessType.code == 'BROKER' ? recommendMobile : undefined,
            opId: payAccessType.code == 'OPERATION' ? companyItem.companyId : undefined,
            status: status.code,
            payTimeStart,
            payTimeEnd,
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getOrderCommonList(query);
        KeepAlive.saveCache({ ...this.state, pageNum: query.pageNum, pageSize: query.pageSize });
    }

    // //生成报表
    // _createHandle = () => {
    //     const reqParams = {
    //     };
    //     http('/earnings/serviceOrderListExcel', { ...reqParams }, 'POST')
    //         .then((res) => {
    //             if (res.errCode === 0) {
    //                 window.open(res.result);
    //             }
    //         })
    //         .catch(e => {
    //             message.error(e.message);
    //         });
    // }

    // 重置触发
    _resetHandle = () => {
        this.setState({ pageSize: 10, pageNum: 1, id: undefined, payAccessType: {}, companyItem: {}, recommendMobile: undefined, status: {}, payTimeStart: undefined, payTimeEnd: undefined }, () => {
            KeepAlive.saveResetFunc(this._searchHandle);
        });
    }

    // 每页pageSize条，当前第pageNum页
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageSize, pageNum }, () => {
            this._searchHandle('useCache');
        });
    }
    startDate = () => {
        this.setState({payTimeEnd: undefined });
    }
    disabledDate = (current) => {
        const { payTimeStart } = this.state;
        let enddays = payTimeStart && moment(payTimeStart);
        return current && current < enddays && enddays.startOf('day');
    }

    render() {
        const { id, payAccessType, recommendMobile, status, payTimeStart, payTimeEnd, companyItem } = this.state;
        const { OrderCommonList, BrokerReferrerRoleEnum = [], OrderStatusEnum, companySele } = this.props;
        const index = BrokerReferrerRoleEnum.findIndex(i => i.code == 0);
        if (index == -1) {
            BrokerReferrerRoleEnum.unshift({ code: 0, value: '全部' });
        }
        return (
            <KeepAlive render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache');
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInputNum
                                label='订单号'
                                placeholder='请输入订单号'
                                value={id}
                                bindThis={this}
                                bindName='id'
                                min={0}
                                precision={0}
                                maxLength={16}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='推广类型'
                                placeholder='请选择推广类型'
                                renderData={BrokerReferrerRoleEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={payAccessType.value}
                                showSearch={true}
                                bindThis={this}
                                bindName='payAccessType'
                            />
                        </SearchItem>
                        { payAccessType.code == 'BROKER' ? <SearchItem>
                            <XInput
                                label='推广账户'
                                placeholder='请输入推广账户'
                                value={recommendMobile}
                                bindThis={this}
                                bindName='recommendMobile'
                            />
                        </SearchItem> : payAccessType.code == 'OPERATION' ?
                        <SearchItem>
                            <XSelect
                                label='运营公司'
                                placeholder='请选择运营公司'
                                renderData={companySele.dataList}
                                dataIndex='companyName'
                                keyIndex='companyId'
                                value={companyItem.companyName}
                                bindThis={this}
                                bindName='companyItem'
                                showSearch={true}
                            />
                        </SearchItem> : null }
                        <SearchItem>
                            <XSelect
                                label='状态'
                                placeholder='请选择状态'
                                renderData={OrderStatusEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                                showSearch={true}
                                bindThis={this}
                                bindName='status'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XDatePicker
                                label='付款时间'
                                value={payTimeStart}
                                bindThis={this}
                                bindName='payTimeStart'
                                isFormat
                                showTime={false}
                                defaultTime='00:00:00'
                                onChange={this.startDate}
                            />
                            <div className={styles.timeLine} />
                            <XDatePicker
                                style={{ marginRight: 20 }}
                                label=''
                                value={payTimeEnd}
                                bindThis={this}
                                bindName='payTimeEnd'
                                isFormat
                                showTime={false}
                                defaultTime='23:59:59'
                                disabledDate={this.disabledDate}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    {/* <ButtonPerssion code='ordermanage/valueserviceorder/dc'>
                    <div className={styles.row2}>
                        <XOKButton
                            style={{ width: 'auto' }}
                            loading={this.state.shareLoading}
                            label='生成报表'
                            onClick={this._createHandle}
                        />
                    </div>
                    </ButtonPerssion> */}
                    <TableContent
                        renderData={OrderCommonList}
                        tableAction={this._tableAction}
                        paginationChange={this._paginationChange}
                    />
                </div>
            </KeepAlive>
        );
    }
}

Main.propTypes = {
    match: PropTypes.object,
    history: PropTypes.object, // 路由
    getOrderCommonList: PropTypes.func,
    OrderCommonList: PropTypes.object,
    getBrokerReferrerRoleEnum: PropTypes.func,
    BrokerReferrerRoleEnum: PropTypes.array,
    getOrderStatusEnum: PropTypes.func,
    OrderStatusEnum: PropTypes.array,
    getCompanySele: PropTypes.func,
    companySele: PropTypes.object,
    setBreadcrumbPaths: PropTypes.func,
};
const mapStateToProps = (state) => ({
    OrderCommonList: state.serviceorder.OrderCommonList,
    BrokerReferrerRoleEnum: state.serviceorder.BrokerReferrerRoleEnum,
    OrderStatusEnum: state.serviceorder.OrderStatusEnum,
    companySele: state.operationCity.companySele,
});
export default connect(mapStateToProps, { setBreadcrumbPaths, ...model.actions, ...commonModel.actions })(Main);